import {HexMath} from "../../HexMath";
import {coordsToKey} from "../../coords/coordsToKey";
import {QUARTERS_OF_DIFFERENT_CITIES_MIN_HEXES_BETWEEN} from "../../../constants/construction";
import {ConstructionAccessibility} from "../../ConstructionAccessibility";
import {TOKENS} from "../../../constants/tokens";

/**
 * Рассчитывает ячейки, на которых запрещено строительство обычного (базового) квартала
 * Заблокированными являются все ячейки из списка заблокированных для центрального квартала,
 * кроме ячеек которые непосредственно соседствуют с центральными кварталами текущего игрока
 *
 * @param hexes
 * @param {Object} citiesCache - кэш городов
 * @param {string} currentPlayerColor - цвет текущего игрока
 * @param blockedCellsForCentralQuarterBySelf
 * @param blockedCellsForCentralQuarterByEnemies
 * @returns {Set<string>} набор ключей заблокированных ячеек для базового квартала
 */
export const calculateBlockedConstructionCellsForBaseQuarter = (
  hexes, citiesCache, currentPlayerColor, blockedCellsForCentralQuarterBySelf, blockedCellsForCentralQuarterByEnemies
) => {
  const hexMath = new HexMath(30, 'flat');
  const constructionAccessibility = new ConstructionAccessibility(hexMath);

  const availableAdjacentToCentralQuarterCells = new Set();

  // Получаем города текущего игрока
  const currentPlayerCities = citiesCache[currentPlayerColor] || [];

  // Собираем все центральные кварталы городов текущего игрока
  currentPlayerCities.forEach(city => {
    const [q, r] = city.centralQuarter.split(',').map(Number);

    // Получаем все соседние ячейки к этому центральному кварталу
    const neighbors = hexMath.getNeighborsFlatTop(q, r);

    neighbors.forEach(([nq, nr]) => {
      const neighborKey = coordsToKey(nq, nr);

      const reachableCells = constructionAccessibility.findReachableCells(
        neighborKey,
        QUARTERS_OF_DIFFERENT_CITIES_MIN_HEXES_BETWEEN,
        hexes,
      );
      const isBlockedByOtherSelfCity = currentPlayerCities.some(otherCity => {
        if(otherCity.centralQuarter === city.centralQuarter) {
          return false;
        }

        if(reachableCells.has(otherCity.centralQuarter)) {
          return true;
        }

        return (otherCity[TOKENS.QUARTER] || []).some(quarter => {
          return reachableCells.has(quarter);
        });
      })

      if(!isBlockedByOtherSelfCity) {
        availableAdjacentToCentralQuarterCells.add(neighborKey);
      }
    });
  });

  // Создаем новый набор заблокированных ячеек для базового квартала
  const blockedCellsForBaseQuarterBySelf = new Set();

  // Включаем все ячейки из списка заблокированных для центрального квартала
  blockedCellsForCentralQuarterBySelf.forEach(cellKey => {
    // Исключаем ячейки, которые являются соседними к центральным кварталам игрока
    if (!availableAdjacentToCentralQuarterCells.has(cellKey)) {
      blockedCellsForBaseQuarterBySelf.add(cellKey);
    }
  });

  return new Set([...blockedCellsForBaseQuarterBySelf, ...blockedCellsForCentralQuarterByEnemies]);
};
